import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/indent-provider/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/indent-provider/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/mobile-nav/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/mobile-nav/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/nested/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/nested/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/snap-points/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/snap-points/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/swipe-area/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/swipe-area/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/uncontained/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/uncontained/tailwind/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/position/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/drawer/demos/non-modal/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.4_@types+react@19.2.14_next@16.1.7_@babel+core@7_7044fa6b7ff6dd7fd87b970ef1a3d670/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CodeHighlighterClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.4_@types+react@19.2.14_next@16.1.7_@babel+core@7_7044fa6b7ff6dd7fd87b970ef1a3d670/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.1.7_@babel+core@7.29.0_@playwright+test@1.59.1_babel-plugin-react-compiler@1.0._01582baedb0408169f7f427edd182fd3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DialogStore"] */ "/opt/build/repo/packages/react/src/dialog/store/DialogStore.ts");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerBackdrop"] */ "/opt/build/repo/packages/react/src/drawer/backdrop/DrawerBackdrop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerClose"] */ "/opt/build/repo/packages/react/src/drawer/close/DrawerClose.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerContent"] */ "/opt/build/repo/packages/react/src/drawer/content/DrawerContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerDescription"] */ "/opt/build/repo/packages/react/src/drawer/description/DrawerDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerIndentBackground"] */ "/opt/build/repo/packages/react/src/drawer/indent-background/DrawerIndentBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerIndent"] */ "/opt/build/repo/packages/react/src/drawer/indent/DrawerIndent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerPopup"] */ "/opt/build/repo/packages/react/src/drawer/popup/DrawerPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerPortal"] */ "/opt/build/repo/packages/react/src/drawer/portal/DrawerPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerProvider"] */ "/opt/build/repo/packages/react/src/drawer/provider/DrawerProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerRoot"] */ "/opt/build/repo/packages/react/src/drawer/root/DrawerRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerSwipeArea"] */ "/opt/build/repo/packages/react/src/drawer/swipe-area/DrawerSwipeArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerTitle"] */ "/opt/build/repo/packages/react/src/drawer/title/DrawerTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerTrigger"] */ "/opt/build/repo/packages/react/src/drawer/trigger/DrawerTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerViewport"] */ "/opt/build/repo/packages/react/src/drawer/viewport/DrawerViewport.tsx");
